"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHaveFeature = exports.reset = exports.ldClientInstance = exports.initFeatureFlags = exports.formatUser = void 0;
var _featureFlags = require("@studio/feature.flags/featureFlags");
/**
 * This file here is to be removed in the last PR in this effort
 * All methods and instances here are temporarily replaced with their equivalents in @studio/feature.flags
 * This is to ensure that the feature flags are still working as expected
 * All usages of the feature flags methods in polymer will be replaced with the new ones in @studio/feature.flags
 */

var ldClientInstance = exports.ldClientInstance = _featureFlags.ldClientInstance;
var formatUser = exports.formatUser = _featureFlags.formatUser;

/**
 * Initialize the feature toggler client with the user data
 */
var initFeatureFlags = exports.initFeatureFlags = _featureFlags.initFeatureFlags;

/**
 * Check to see if we should show a feature
 */
var shouldHaveFeature = exports.shouldHaveFeature = _featureFlags.shouldHaveFeature;
var reset = exports.reset = function reset() {
  return exports.ldClientInstance = ldClientInstance = undefined;
};